<style lang="stylus" scoped>
.headersearchwrap
  position: relative
  .headersearchtitle
    width: 100%
    height: 100%
    display: flex
    align-items: center
    padding: 0 7px
  .headersousuowrap
    position: absolute
    top: 100%
    right: 0
    width: 392px
</style>

<template>
  <div class="headersearchwrap" style="padding: 0" v-clickOutSide="closePanel">

    <div>
      <vsearch type="bannersearch"></vsearch>
    </div>
  </div>
</template>

<script>
import vsearch from "@/components/search/headerSearchs";

export default {
  name: 'HeaderSearch',
  data() {
    return {
      headerSearchPanel: false
    }
  },
  components: {vsearch},
  methods: {
    closePanel() {
      // this.headerSearchPanel = false;
      this.$emit('searchInput', false)
    },
    toggleheadersearchpanel() {
      this.headerSearchPanel = !this.headerSearchPanel;
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/search/headerSearch.vue